import { render, staticRenderFns } from "./signInLayout.vue?vue&type=template&id=1ffd719e"
import script from "./signInLayout.vue?vue&type=script&lang=ts"
export * from "./signInLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports